import {
  deferPlanningBackgroundWorkUntilIdle,
  tryBeginPlanningMutationActivity,
} from "./planningMutationActivity.js";

export const METADATA_SYNC_ACTIVITY_MESSAGE = "Synchronisation des données en cours…";

// A metadata write uses the same exclusive activity as manual planning writes.
// Keep it until the caller has installed the resulting planning and preview.
export function acquireSourceChangeMetadataSyncActivity({ isCurrent } = {}) {
  const key = Symbol("source-change-metadata-sync");
  let waited = false;
  return new Promise((resolve) => {
    const acquire = () => {
      if (isCurrent?.() === false) {
        resolve(null);
        return;
      }
      // Final update reads can require this internal write before releasing the update activity.
      const finish = tryBeginPlanningMutationActivity({ message: METADATA_SYNC_ACTIVITY_MESSAGE, allowDuringUpdate: true });
      if (finish) {
        resolve({ finish, waited });
        return;
      }
      waited = true;
      deferPlanningBackgroundWorkUntilIdle(key, acquire);
    };
    acquire();
  });
}
